import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import IconSettingClass from '../../../../../../components/settingsIcon';
import EarningsCodes from './EarningsCodes';
import DeductionsView from './Deductions';
import WPSavedReports from './SavedReports';
import RateConfig from './RateConfig';
import { getSavedEarningsCodes } from '../../../../../../store/actions';

const WageParityReportSettings = props => {
    const { companyId } = props.ClientDataReducer;
    const [earningCodes, setEarningCodes] = useState({});

    useEffect(() => {
        const getEC = async () => {
            await props.getSavedEarningsCodes(companyId);
            setEarningCodes({ ...props.SavedECReducer });
        };
        getEC();
    }, []);
    return (
        <Accordion>
            <AccordionSummary
                expandIcon={<IconSettingClass />}
                aria-controls="panel1a-content"
                id="panel1a-header"
            >
                <Typography className="reportTitle">Wage parity report</Typography>
            </AccordionSummary>

            <AccordionDetails>
                <div className="reportListAccording mar-0">
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Typography className="titleAccording">Earning codes</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <EarningsCodes companyId={props.ClientDataReducer.companyId}></EarningsCodes>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2a-content"
                            id="panel2a-header"
                        >
                            <Typography className="titleAccording">Deductions</Typography>
                        </AccordionSummary>
                        <AccordionDetails>

                            <DeductionsView
                                USER={props.UserReducer}
                                companyId={props.ClientDataReducer.companyId}
                                companyShortName={props.ClientDataReducer.companyShortName}
                                savedEarningsCodes={earningCodes}
                            ></DeductionsView>
                        </AccordionDetails>
                    </Accordion>

                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2a-content"
                            id="panel2a-header"
                        >
                            <Typography className="titleAccording">Saved reports</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <WPSavedReports companyId={props.ClientDataReducer.companyId}
                            ></WPSavedReports>
                        </AccordionDetails>
                    </Accordion>

                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2a-content"
                            id="panel2a-header">
                            <Typography className="titleAccording">Rate config</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <RateConfig ></RateConfig>
                        </AccordionDetails>
                    </Accordion>
                </div>


            </AccordionDetails>
        </Accordion>
    )

};

const mapStateToProps = ({ UserReducer, ClientDataReducer, SavedECReducer }) => {
    return { UserReducer, ClientDataReducer, SavedECReducer };
};

export default connect(mapStateToProps, { getSavedEarningsCodes })(WageParityReportSettings);